import {
  Exercise,
  Lecture,
  Tutorial,
  Section,
  NoTimeExercise,
  StaffExercise,
} from 'Utils/TutorialConfigHelper';
import { AddEventsAndMergeTimestamps, Timestamps } from 'Utils/ChaptersToTimestamps';
import timestamps from './level12.json';

const Level12 = Tutorial(12, '1:24', [
  Section([
    Lecture('Building Harmony in 4/4', '0:0'),
    Exercise(
      'Hands Separate + Together',
      '0:24',
      NoTimeExercise({
        centre_align_horizontal: true,
        first_note_offset: 50,
        objectives: [{}, {}],
      }),
      [],
    ),
    Exercise(
      'Playing in Time',
      '0:40',
      StaffExercise({
        objectives: [{}, {}],
      }),
      [],
    ),
  ]),
  Section([
    Lecture('Hands Together', '0:50'),
    Exercise(
      'Hands Together',
      '1:09',
      StaffExercise({
        objectives: [{}, {}],
      }),
      [],
    ),
  ]),
]);

export default AddEventsAndMergeTimestamps(timestamps as Timestamps, Level12);
